import { Commit, ActionTree } from 'vuex';
import { State } from './overview.store';
import graphQl from '@/services/graphQl';
import { AxiosResponse } from 'axios';

const actions: ActionTree<State, any> = {
	async GET_VM_META(
		context: { commit: Commit },
		params: {
			keyword: String;
			filterCondition: {
				scope: String;
				metricType: String;
				order: String;
			};
			pagination: {
				pageNum: Number;
				pageSize: Number;
			};
			duration: {
				start: String;
				end: String;
				step: String;
			};
			serviceReq: {
				capability: String;
				teamID: String;
				subType: String;
			};
		}
	) {
		if (!params) {
			return new Promise<void>(resolve => resolve());
		}
		return graphQl
			.query('queryGetTeamApplication')
			.params(params)
			.then((res: AxiosResponse) => {
				if (res.data) {
					return res.data.data.getTeamApplicationOverview;
				} else return [];
			});
	},

	async GET_VM_INSTANCE_META(
		context: { commit: Commit },
		params: {
			keyword: String;
			filterCondition: {
				scope: String;
				metricType: String;
				order: String;
			};
			pagination: {
				pageNum: Number;
				pageSize: Number;
				needTotal: Boolean;
			};
			duration: {
				start: String;
				end: String;
				step: String;
			};
			serviceReq: {
				capability: String;
				serviceId: String;
				teamID: String;
				subType: String;
			};
		}
	) {
		if (!params) {
			return new Promise<void>(resolve => resolve());
		}
		return graphQl
			.query('queryGetServiceInstancesOverview')
			.params(params)
			.then((res: AxiosResponse) => {
				if (res.data) {
					return res.data.data.getServiceInstancesOverview;
				} else return [];
			});
	},
	async GET_APM_INFRA_META(
		context: { commit: Commit },
		params: {
			filterCondition: {
				scope: String;
				metricType: String;
				order: String;
			};
			pagination: {
				pageNum: Number;
				pageSize: Number;
				needTotal: Boolean;
			};
			duration: {
				start: String;
				end: String;
				step: String;
			};
			correlationReq: {
				sourceCapability: String;
				correlatedCapability: String;
				serviceId: String;
			};
		}
	) {
		if (!params) {
			return new Promise<void>(resolve => resolve());
		}
		return graphQl
			.query('queryGetCapabilityCorrelatedOverview')
			.params(params)
			.then((res: AxiosResponse) => {
				if (res.data) {
					return res.data.data.getCapabilityCorrelatedOverviewData;
				} else return [];
			});
	}
};

export default actions;
